import React from 'react';
import { IpaType } from "../../phonemes/ipa";

interface SegmentsProps {
  readonly segments: IpaType[];
  readonly onMouseOver?: (ipa: IpaType) => void;
}

/** show a simple list of segments, supporting mouse-over */
export function Segments(props: SegmentsProps) {
  function over(ipa: IpaType) {
    if (props.onMouseOver) {
      props.onMouseOver(ipa);
    }
  }

  return (<td>
    {props.segments.map((s, i) => <span onMouseOver={() => over(s)} key={i}>{s} </span>)}
  </td>);
}
